import { classNames, React, useState } from 'libs/react';
import { TabBar } from 'components/TabBar';
import { TabBarButton } from 'components/TabBarButton';
import { DealTaxBreakdownSection } from './sections/DealTaxBreakdownSection';
import { DealOtherFeesBreakdownSection } from './sections/DealOtherFeesBreakdownSection';
import './DealFinancialDetailsModal.scss';
/**
 * @component DealFinancialDetailsModal
 * @since 1.0.0
 *
 * Generic financial breakdown modal for the deal configurator. Tabs isolate
 * independent sections (tax breakdown, automatic other fees) so each can
 * grow without crowding the other.
 */
export function DealFinancialDetailsModal(props) {
    const { deal } = props;
    const [activeTab, setActiveTab] = useState('taxes');
    const className = classNames('deal-financial-details-modal-content', props.className);
    return (React.createElement("div", { className: className },
        React.createElement(TabBar, { className: "deal-financial-details-modal-tabs" },
            React.createElement(TabBarButton, { label: t('Taxes'), selected: activeTab === 'taxes', onPress: () => setActiveTab('taxes') }),
            React.createElement(TabBarButton, { label: t('Other fees'), selected: activeTab === 'other-fees', onPress: () => setActiveTab('other-fees') })),
        React.createElement("div", { className: "deal-financial-details-modal-panel" }, activeTab === 'taxes' ? (React.createElement(DealTaxBreakdownSection, { deal: deal })) : (React.createElement(DealOtherFeesBreakdownSection, { deal: deal })))));
}
